// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"67a03d14","215":"671428db","831":"2390e506","950":"061e715d","960":"d3359c5e"}[chunkId] + ".chunk.css";
};